angular.module('core')
  .service('PendoService', ['$window', function ($window) {
    return {
      initialize: function () {
        if (typeof $window.pendo !== 'undefined') {
          $window.pendo.initialize();
        }
      }
    };
  }]);
